if (!customElements.get('discount-table')) {
    class DiscountTable extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        //this.init();
      }
  
      init() {
        const productForm = document.querySelector('.product-info');
        if (!productForm) return;
  
        productForm.addEventListener('change', event => {
          const target = event.target;
          if (target.matches('input, select')) {
            setTimeout(() => {
              //this.optionUpdate(productForm);
            }, 50);
          }
        });
      }
  
      optionUpdate(e) {
        const priceEl = e.querySelector('.price__current');
        if (!priceEl) {
          return;
        }
  
        const priceText = priceEl.textContent.replace(/[^\d]/g, "");
        const priceValue = parseFloat(priceText);
        const discountValue = parseInt(this.getAttribute('data-price-first')) || 0;
        const discountValueSecond = parseInt(this.getAttribute('data-price-second')) || 0;
        const discountValueThird = parseInt(this.getAttribute('data-price-third')) || 0;
        const options = this.querySelectorAll('.product-info__discount-display--info');
  
        
        options.forEach(opt => {
          opt.classList.remove('active');
        });
  
        if (discountValueThird) {
          if (priceValue >= discountValueThird) {
            options[2]?.classList.add('active');
            this.classList.remove('hidden');
          } else if (priceValue >= discountValueSecond) {
            options[1]?.classList.add('active');
            this.classList.remove('hidden');
          } else if (priceValue >= discountValue) {
            options[0]?.classList.add('active');
            this.classList.remove('hidden');
          } else {
            this.classList.add('hidden');
          }
        } else if (discountValueSecond && !discountValueThird) {
          if (priceValue >= discountValueSecond) {
            options[1]?.classList.add('active');
            this.classList.remove('hidden');
          } else if (priceValue >= discountValue) {
            options[0]?.classList.add('active');
            this.classList.remove('hidden');
          } else {
            this.classList.add('hidden');
          }
        } else {
          if (priceValue >= discountValue) {
            options[0]?.classList.add('active');
            this.classList.remove('hidden');
          } else {
            this.classList.add('hidden');
          }
        }
      }
    }
  
    customElements.define('discount-table', DiscountTable);
  }
  